/* eslint-disable max-len */
import React, {Fragment, useEffect, useState} from "react";
import Card from "../Card";
import "../../stylesheets/screen.css.scss";
import dataFile from "../../Data/dataFile.json";

import {Link} from "react-router-dom";
function ApiContainer() {
  const data = dataFile["entitiesConfig"];

  const apiItems = Object.keys(data).map((key) => {
    const item = data[key];
    return (
      <Fragment key={item.name}>
        <Link to={`/card/${item.name.replace(" ", "-")}`} key={item.name}>
          <Card {...item} />
        </Link>
      </Fragment>
    );
  });

  return (
    <div className="api-container" data-testid="api-container">
      <h1 className="heading">List of Phenom API</h1>
      <div className="api-list">{apiItems}</div>
    </div>
  );
}

export default ApiContainer;
